module.exports = __webpack_public_path__ + "static/img/teach3.4b145c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upiTeaching/teach3.png
// module id = rpQd
// module chunks = 0